"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.f118 = void 0;
exports.f118 = {
    "vaga": [
        38
    ],
    "vaiverang": [
        101
    ],
    "vn": [
        123,
        701,
        933,
        935,
        1080,
        1100,
        1481,
        1485,
        1486,
        1487,
        1529,
        1536,
        1543,
        1622,
        1680,
        2229,
        2650,
        2651,
        2883,
        2887,
        2896,
        2966,
        2977,
        2994,
        3034,
        3047,
        3048,
        3051,
        3120,
        3346,
        3419,
        3710,
        3886,
        3981,
        4002,
        4127,
        4208,
        4235,
        4302,
        4313,
        4359,
        4551,
        4877,
        4941,
        4949,
        4970,
        5117,
        5402,
        5723,
        5738,
        5745,
        6017,
        6019,
        6123,
        6124,
        6365,
        6457,
        6501,
        6511,
        6564,
        6582,
        6586,
        6719,
        6777,
        7163,
        7165,
        7177,
        7319,
        7401,
        7555,
        7601,
        7654,
        7740,
        7825,
        7826,
        7863,
        7865,
        7866,
        7867,
        7870,
        7871,
        7872,
        7873,
        7878,
        8078,
        8079,
        8080,
        8402,
        8481,
        9042,
        9045,
        9110
    ],
    "viet nam": [
        123,
        701,
        933,
        935,
        1080,
        1100,
        1481,
        1485,
        1486,
        1487,
        1529,
        1536,
        1543,
        1622,
        1680,
        2229,
        2650,
        2651,
        2883,
        2887,
        2896,
        2966,
        2977,
        2994,
        3034,
        3047,
        3048,
        3051,
        3120,
        3346,
        3419,
        3710,
        3886,
        3981,
        4002,
        4127,
        4208,
        4235,
        4302,
        4313,
        4359,
        4551,
        4877,
        4941,
        4949,
        4970,
        5117,
        5402,
        5723,
        5738,
        5745,
        6017,
        6019,
        6123,
        6124,
        6365,
        6457,
        6501,
        6511,
        6564,
        6582,
        6586,
        6719,
        6777,
        7163,
        7165,
        7177,
        7319,
        7401,
        7555,
        7601,
        7654,
        7740,
        7825,
        7826,
        7863,
        7865,
        7866,
        7867,
        7870,
        7871,
        7872,
        7873,
        7878,
        8078,
        8079,
        8080,
        8402,
        8481,
        9042,
        9045,
        9110
    ],
    "viet": [
        8078,
        8079,
        8080,
        4313,
        5745,
        123,
        701,
        933,
        935,
        1080,
        1100,
        1481,
        1485,
        1486,
        1487,
        1529,
        1536,
        1543,
        1622,
        1680,
        2229,
        2650,
        2651,
        2883,
        2887,
        2896,
        2966,
        2977,
        2994,
        3034,
        3047,
        3048,
        3051,
        3120,
        3346,
        3419,
        3710,
        3886,
        3981,
        4002,
        4127,
        4208,
        4235,
        4302,
        4359,
        4551,
        4877,
        4941,
        4949,
        4970,
        5117,
        5402,
        5723,
        5738,
        6017,
        6019,
        6123,
        6124,
        6365,
        6457,
        6501,
        6511,
        6564,
        6582,
        6586,
        6719,
        6777,
        7163,
        7165,
        7177,
        7319,
        7401,
        7555,
        7601,
        7654,
        7740,
        7825,
        7826,
        7863,
        7865,
        7866,
        7867,
        7870,
        7871,
        7872,
        7873,
        7878,
        8402,
        8481,
        9042,
        9045,
        9110
    ],
    "vu": [
        177,
        248,
        268,
        360,
        384,
        508,
        519,
        836,
        892,
        982,
        989,
        1026,
        1088,
        1159,
        1600,
        1865,
        2222,
        2247,
        2250,
        2307,
        2405,
        2463,
        2475,
        2495,
        2953,
        3149,
        3786,
        3932,
        4304,
        4321,
        4367,
        4388,
        4394,
        4405,
        4413,
        4433,
        4468,
        4487,
        4488,
        4559,
        4566,
        4867,
        4875,
        4885,
        4895,
        4897,
        4905,
        4907,
        4913,
        4922,
        4947,
        5040,
        5052,
        5056,
        5059,
        5086,
        5120,
        5168,
        5182,
        5187,
        5209,
        5522,
        5562,
        5572,
        5582,
        5594,
        5668,
        5706,
        5753,
        5765,
        5897,
        5905,
        5934,
        6115,
        6183,
        6203,
        6326,
        6348,
        6351,
        6506,
        6596,
        6685,
        6916,
        6933,
        7010,
        7151,
        7250,
        7457,
        7460,
        7573,
        7579,
        7588,
        7597,
        7607,
        7622,
        7623,
        7625,
        7627,
        7684,
        7744,
        7807,
        7986,
        8006,
        8031,
        8056,
        8102,
        8129,
        8130,
        8135,
        8138,
        8264,
        8347,
        8377
    ],
    "vanuatu": [
        2307,
        3932,
        6916,
        8031,
        177,
        248,
        268,
        360,
        384,
        508,
        519,
        836,
        892,
        982,
        989,
        1026,
        1088,
        1159,
        1600,
        1865,
        2222,
        2247,
        2250,
        2405,
        2463,
        2475,
        2495,
        2953,
        3149,
        3786,
        4304,
        4321,
        4367,
        4388,
        4394,
        4405,
        4413,
        4433,
        4468,
        4487,
        4488,
        4559,
        4566,
        4867,
        4875,
        4885,
        4895,
        4897,
        4905,
        4907,
        4913,
        4922,
        4947,
        5040,
        5052,
        5056,
        5059,
        5086,
        5120,
        5168,
        5182,
        5187,
        5209,
        5522,
        5562,
        5572,
        5582,
        5594,
        5668,
        5706,
        5753,
        5765,
        5897,
        5905,
        5934,
        6115,
        6183,
        6203,
        6326,
        6348,
        6351,
        6506,
        6596,
        6685,
        6933,
        7010,
        7151,
        7250,
        7457,
        7460,
        7573,
        7579,
        7588,
        7597,
        7607,
        7622,
        7623,
        7625,
        7627,
        7684,
        7744,
        7807,
        7986,
        8006,
        8056,
        8102,
        8129,
        8130,
        8135,
        8138,
        8264,
        8347,
        8377
    ],
    "ve": [
        346,
        613,
        1216,
        1230,
        1345,
        1477,
        1689,
        2285,
        2512,
        2572,
        2822,
        3424,
        4631,
        4632,
        4784,
        6047,
        6048,
        6104,
        6145,
        7050,
        7612,
        8140,
        8175,
        8322,
        8397,
        8642,
        8721,
        8737,
        8740,
        8944
    ],
    "venezuela": [
        346,
        613,
        1216,
        1230,
        1345,
        1477,
        1689,
        2285,
        2512,
        2572,
        2822,
        3424,
        4631,
        4632,
        4784,
        6047,
        6048,
        6104,
        6145,
        7050,
        7612,
        8140,
        8175,
        8322,
        8397,
        8642,
        8721,
        8737,
        8740,
        8944
    ],
    "vacacocha": [
        467,
        541
    ],
    "viri": [
        1204,
        1212,
        470,
        1122
    ],
    "ventre": [
        502
    ],
    "ventres": [
        502
    ],
    "vouaousi": [
        515
    ],
    "vernacular": [
        582,
        585,
        9184
    ],
    "vengo": [
        628
    ],
    "vengi": [
        628
    ],
    "vengoo": [
        628
    ],
    "varama": [
        640
    ],
    "vә mvәran": [
        653
    ],
    "vә": [
        653
    ],
    "vadagu": [
        759,
        760,
        761,
        762
    ],
    "vaghri": [
        8076,
        783,
        2659,
        2660,
        8045
    ],
    "vil": [
        806,
        807
    ],
    "vyak": [
        832
    ],
    "vaikenu": [
        908
    ],
    "vaikino": [
        908
    ],
    "vaaneroki": [
        909
    ],
    "vella lavella": [
        913
    ],
    "vella": [
        913
    ],
    "vuolo": [
        917
    ],
    "virac": [
        924
    ],
    "vonun": [
        985
    ],
    "vunum": [
        985
    ],
    "vunun": [
        985
    ],
    "vunung": [
        985
    ],
    "valupai": [
        987
    ],
    "vakweli": [
        1087
    ],
    "vambeng": [
        1087
    ],
    "vovo": [
        1088
    ],
    "van kieu": [
        1100,
        1101,
        1102
    ],
    "van": [
        1100,
        1101,
        1102,
        6017,
        6018,
        6019
    ],
    "visayak": [
        1117
    ],
    "vesi": [
        1119
    ],
    "vove": [
        1192
    ],
    "von": [
        1288,
        1303,
        3463,
        6279,
        8030
    ],
    "valencian": [
        8141,
        1323,
        1324,
        1325,
        1326,
        1327
    ],
    "vaj": [
        1381,
        1382,
        1383,
        1384
    ],
    "visayan": [
        1409,
        1410,
        1712
    ],
    "viggé-biaundo mission": [
        1568
    ],
    "viggé-biaundo": [
        1568
    ],
    "vc": [
        1599,
        2219,
        7217
    ],
    "vincent": [
        1599,
        2219,
        7217
    ],
    "valle": [
        1702,
        5645,
        5983
    ],
    "valle nacional chinantec": [
        1702
    ],
    "vi": [
        1770,
        2221
    ],
    "virgin": [
        8081,
        1770,
        2220,
        2221
    ],
    "valley": [
        1914,
        1918,
        1925,
        3742,
        8122,
        8488,
        8719,
        8970,
        6220,
        2391,
        8991
    ],
    "villa": [
        2034,
        8990,
        5121,
        7649,
        8127,
        8972,
        8986,
        8988
    ],
    "viciosa": [
        2034
    ],
    "villa viciosa agta": [
        2034
    ],
    "véhiculaire": [
        2040,
        2041,
        2042
    ],
    "vhe": [
        2060,
        2061
    ],
    "vasco": [
        2115
    ],
    "vg": [
        2220
    ],
    "ven": [
        2229
    ],
    "vowak": [
        2233
    ],
    "villu vedan": [
        2246
    ],
    "villu": [
        2246
    ],
    "vedan": [
        2246,
        4834
    ],
    "vilvedan": [
        2246
    ],
    "viipekeel": [
        2295
    ],
    "vosa": [
        2393
    ],
    "vakaviti": [
        2393
    ],
    "vimtim": [
        2398
    ],
    "vai fordata": [
        2467
    ],
    "vai": [
        8050,
        8051,
        2467
    ],
    "vai sera-larat-fordata": [
        2467
    ],
    "vai tnebar": [
        2467
    ],
    "vaidida": [
        2467
    ],
    "vara kiai": [
        2475
    ],
    "vara": [
        2475,
        7363
    ],
    "viittomakieli": [
        2476,
        2478
    ],
    "vandu gelao": [
        2651
    ],
    "vandu": [
        2651
    ],
    "voa dê": [
        2651
    ],
    "voa": [
        2651
    ],
    "vagari": [
        2659,
        2660,
        8189
    ],
    "vagaria": [
        2659,
        2660
    ],
    "vaal–orange": [
        2673,
        3918
    ],
    "vale": [
        8046,
        2686
    ],
    "vana": [
        2827
    ],
    "valiente": [
        2865
    ],
    "vietnamese": [
        8078,
        8079,
        8080,
        2887,
        7319,
        2883,
        3034
    ],
    "vietnamese sign language": [
        2883,
        2887,
        3034
    ],
    "vixaritari vaniuqui": [
        2917
    ],
    "vixaritari": [
        2917
    ],
    "vaniuqui": [
        2917
    ],
    "vizaritari vaniuki": [
        2917
    ],
    "vizaritari": [
        2917
    ],
    "vaniuki": [
        2917
    ],
    "vәcәmwe": [
        2942
    ],
    "vách": [
        3047,
        3048
    ],
    "vach": [
        3047,
        3048
    ],
    "veliche": [
        3078
    ],
    "vula’a": [
        3082
    ],
    "vulaa": [
        3082
    ],
    "vodoun": [
        3096
    ],
    "vasha": [
        3224
    ],
    "va": [
        8146,
        8186,
        3264,
        4185,
        5262
    ],
    "vatican": [
        3264,
        4185,
        5262
    ],
    "vaghat": [
        3329
    ],
    "vaghat-ya-bijim-legeri": [
        3329
    ],
    "vou": [
        3372
    ],
    "vira": [
        3410
    ],
    "vono": [
        3513
    ],
    "verdean": [
        3558
    ],
    "verde": [
        3558,
        6332
    ],
    "veveu evav": [
        3566
    ],
    "veveu": [
        3566
    ],
    "valmiki": [
        3584
    ],
    "vinahә": [
        3681
    ],
    "vakwángali": [
        4086
    ],
    "valaangi": [
        4195
    ],
    "vure": [
        4367
    ],
    "vunmarama": [
        4405
    ],
    "vanjari": [
        4406,
        4407,
        4408
    ],
    "varmali": [
        4413
    ],
    "valoda": [
        4496,
        4542
    ],
    "varsu": [
        4559
    ],
    "vega": [
        4624,
        9131,
        9142,
        9145
    ],
    "vïdï morokodo": [
        4741
    ],
    "vïdï": [
        4741
    ],
    "vo": [
        4787,
        8186,
        5921
    ],
    "vazhiyammar": [
        4833
    ],
    "veda bhasha": [
        4834
    ],
    "veda": [
        4834,
        8070
    ],
    "vedans": [
        4834
    ],
    "vettava bhasha": [
        4834
    ],
    "vettava": [
        4834
    ],
    "vә́na mίy": [
        4851
    ],
    "vә́na": [
        4851
    ],
    "vamale": [
        4865
    ],
    "vame": [
        4892
    ],
    "vamé": [
        4892
    ],
    "vogul": [
        4953
    ],
    "vogulich": [
        4953
    ],
    "voguly": [
        4953
    ],
    "vangunu": [
        5001
    ],
    "valles": [
        5016
    ],
    "vineyard": [
        5043
    ],
    "vurës": [
        5086
    ],
    "vetumboso": [
        5086
    ],
    "vuras": [
        5086
    ],
    "vureas": [
        5086
    ],
    "vaa": [
        5255
    ],
    "va’a": [
        5255
    ],
    "veteng": [
        5360
    ],
    "vetweng": [
        5360
    ],
    "veracruz": [
        5465
    ],
    "vagahau niuē": [
        5486
    ],
    "vagahau": [
        5486
    ],
    "vlaams": [
        5536,
        5540,
        8103
    ],
    "v’ënen taut": [
        5562
    ],
    "v’ënen": [
        5562
    ],
    "v'ënen taut": [
        5562
    ],
    "vënen": [
        5562
    ],
    "v’ənen taut": [
        5562
    ],
    "v’ənen": [
        5562
    ],
    "vo limkou": [
        5921
    ],
    "vadiya": [
        5948,
        5949
    ],
    "vailala": [
        5956
    ],
    "vicente": [
        9139,
        6046
    ],
    "vuite": [
        6075
    ],
    "vadval": [
        6122
    ],
    "virginia algonkian": [
        6153
    ],
    "virginia": [
        6153
    ],
    "virginia algonquian": [
        6153
    ],
    "vaeakau-taumako": [
        6161
    ],
    "voum": [
        6203
    ],
    "veroo": [
        6205
    ],
    "valley miwok": [
        6220
    ],
    "venaambakaia": [
        6259
    ],
    "venambakaiia": [
        6259
    ],
    "vupuran": [
        6279
    ],
    "vasi vari": [
        6294
    ],
    "vasi": [
        6294
    ],
    "vari": [
        6294
    ],
    "veron": [
        6294
    ],
    "verou": [
        6294
    ],
    "veruni": [
        6294
    ],
    "vato": [
        6351
    ],
    "vinuculjan": [
        6379
    ],
    "voshanange kalá": [
        6563
    ],
    "voshanange": [
        6563
    ],
    "vlax": [
        6590,
        6588
    ],
    "vlax romany": [
        6588,
        6590
    ],
    "vlach": [
        6627,
        6628
    ],
    "vlav": [
        6627,
        6628
    ],
    "vani": [
        6650,
        6651,
        6652,
        6653,
        6654,
        6655,
        6656,
        6657
    ],
    "vigzar": [
        6686
    ],
    "vikzar": [
        6686
    ],
    "vori": [
        6750
    ],
    "viid": [
        7011
    ],
    "vulung": [
        7134
    ],
    "vincentian english creole": [
        7217
    ],
    "vincentian": [
        7217
    ],
    "vincentian creole english": [
        7217
    ],
    "vincy twang": [
        7217
    ],
    "vincy": [
        7217
    ],
    "vietnamese pidgin french": [
        7319
    ],
    "vanatinai": [
        7456
    ],
    "vanga": [
        7456
    ],
    "vava": [
        7588
    ],
    "vasui": [
        7682
    ],
    "vasuii": [
        7682
    ],
    "vatsonga": [
        7727,
        7728
    ],
    "vaghua": [
        7804
    ],
    "vagua": [
        7804
    ],
    "vatlongos": [
        7807
    ],
    "vateve": [
        7837
    ],
    "venustiano": [
        7888,
        7889,
        7890,
        7891
    ],
    "votiak": [
        7911,
        7912
    ],
    "votyak": [
        7911,
        7912
    ],
    "vehees": [
        8053,
        8034
    ],
    "vaagri booli": [
        8045
    ],
    "vaagri": [
        8045
    ],
    "vaghriwala": [
        8045
    ],
    "vagri": [
        8045
    ],
    "vel": [
        8045
    ],
    "vafsi": [
        8047
    ],
    "vagla": [
        8048
    ],
    "vagala": [
        8048
    ],
    "varhadi-nagpuri": [
        8049
    ],
    "vei": [
        8050,
        8051
    ],
    "vy": [
        8050,
        8051
    ],
    "vasekela bushman": [
        8052
    ],
    "vasekela": [
        8052
    ],
    "vasekele": [
        8052
    ],
    "vehes": [
        8053
    ],
    "vanimo": [
        8054
    ],
    "valman": [
        8055
    ],
    "vao": [
        8056
    ],
    "vaiphei": [
        8057
    ],
    "vaipei": [
        8057
    ],
    "veiphei": [
        8057
    ],
    "varihío": [
        8058
    ],
    "varijío": [
        8058
    ],
    "varohio": [
        8058
    ],
    "vorijío": [
        8058
    ],
    "vasavi": [
        8059,
        8060
    ],
    "vasava": [
        8059,
        8060
    ],
    "vasava bhil": [
        8059,
        8060
    ],
    "vasave": [
        8059,
        8060
    ],
    "vanuma": [
        8061
    ],
    "varli": [
        8062,
        8063
    ],
    "vayu": [
        8064
    ],
    "venda": [
        8067,
        8068
    ],
    "venetian": [
        8069
    ],
    "veneto": [
        8069
    ],
    "venet": [
        8069
    ],
    "vêneto brasileiro": [
        8069
    ],
    "vêneto": [
        8069
    ],
    "veddah": [
        8070
    ],
    "vaedda": [
        8070
    ],
    "vedda": [
        8070
    ],
    "veddha": [
        8070
    ],
    "veluws": [
        8071
    ],
    "veluwe": [
        8071
    ],
    "vemgo-mabas": [
        8072
    ],
    "ventureño": [
        8073
    ],
    "veps": [
        8074
    ],
    "vepsian": [
        8074
    ],
    "vepsish": [
        8074
    ],
    "vepsäks": [
        8074
    ],
    "vepsän keli": [
        8074
    ],
    "vepsän": [
        8074
    ],
    "vepsän kelʹ": [
        8074
    ],
    "verre": [
        8075
    ],
    "vere": [
        8075
    ],
    "vaghri koli": [
        8076
    ],
    "vgt": [
        8077
    ],
    "vlaamse gebarentaal": [
        8077
    ],
    "vlaamse": [
        8077
    ],
    "việt": [
        8078,
        8079,
        8080
    ],
    "virgin islands english creole": [
        8081
    ],
    "virgin islands creole english": [
        8081
    ],
    "vidunda": [
        8082
    ],
    "vili": [
        8083
    ],
    "viemo": [
        8084
    ],
    "vige": [
        8084
    ],
    "vigué": [
        8084
    ],
    "vigye": [
        8084
    ],
    "vilela": [
        8085
    ],
    "vinza": [
        8086
    ],
    "vishavan": [
        8087
    ],
    "viti": [
        8088
    ],
    "vötö": [
        8088
    ],
    "vivigana": [
        8089
    ],
    "vivigani": [
        8089
    ],
    "valpei": [
        8102
    ],
    "valpay": [
        8102
    ],
    "valpei-hukua": [
        8102
    ],
    "vlaemsch": [
        8103
    ],
    "vlamingen": [
        8103
    ],
    "vinitiri": [
        8110
    ],
    "vinitiri lungalungá": [
        8110
    ],
    "vinitiri tuna": [
        8110
    ],
    "valley maidu": [
        8122
    ],
    "vanikolo": [
        8128
    ],
    "vanikoro": [
        8128
    ],
    "vano": [
        8128
    ],
    "vinmavis": [
        8129
    ],
    "vunapu": [
        8130
    ],
    "volapük": [
        8131
    ],
    "voro": [
        8132,
        8136
    ],
    "vod": [
        8133,
        8134
    ],
    "vad́d́a tšeeli": [
        8133,
        8134
    ],
    "vad́d́a": [
        8133,
        8134
    ],
    "vodian": [
        8133,
        8134
    ],
    "vote": [
        8133,
        8134
    ],
    "votian": [
        8133,
        8134
    ],
    "votic": [
        8133,
        8134
    ],
    "votish": [
        8133,
        8134
    ],
    "vera’a": [
        8135
    ],
    "vatrata": [
        8135
    ],
    "vera'a": [
        8135
    ],
    "vetrat": [
        8135
    ],
    "võro": [
        8136
    ],
    "voru": [
        8136
    ],
    "võro kiil": [
        8136
    ],
    "võro-seto": [
        8136
    ],
    "võru": [
        8136
    ],
    "varisi": [
        8137
    ],
    "varese": [
        8137
    ],
    "vartavo": [
        8138
    ],
    "venezuelan sign language": [
        8140
    ],
    "venezuelan": [
        8140
    ],
    "venezolana": [
        8140
    ],
    "valencian sign language": [
        8141
    ],
    "valenciana": [
        8141
    ],
    "valencià": [
        8141
    ],
    "vitou": [
        8142
    ],
    "vumbu": [
        8143
    ],
    "vungu": [
        8143
    ],
    "vunjo": [
        8144
    ],
    "vute": [
        8145
    ],
    "voute": [
        8145
    ],
    "voutere": [
        8145
    ],
    "vutere": [
        8145
    ],
    "vɨtèé": [
        8145
    ],
    "vapidiana": [
        8163
    ],
    "vanda": [
        8179
    ],
    "vwanji": [
        8180
    ],
    "vakhan": [
        8183,
        8184,
        8185
    ],
    "vax": [
        8186
    ],
    "vhax": [
        8186
    ],
    "vadari": [
        8188
    ],
    "vadda beldar": [
        8188
    ],
    "vadda": [
        8188
    ],
    "vagadi": [
        8189
    ],
    "vagdi": [
        8189
    ],
    "vaged": [
        8189
    ],
    "vageri": [
        8189
    ],
    "vagi": [
        8189
    ],
    "veveva": [
        8215
    ],
    "vitu": [
        8242
    ],
    "vittu": [
        8242
    ],
    "vejoz": [
        8267
    ],
    "vejos": [
        8267
    ],
    "vambucauras raduyor": [
        8275
    ],
    "vambucauras": [
        8275
    ],
    "vambule": [
        8275
    ],
    "vambule radu yor": [
        8275
    ],
    "vambule yor": [
        8275
    ],
    "vanambere": [
        8287
    ],
    "vanechi": [
        8290
    ],
    "volof": [
        8302,
        8303
    ],
    "voko": [
        8314
    ],
    "vaskia": [
        8348
    ],
    "viwulu-aua": [
        8372
    ],
    "vilamovian": [
        8385
    ],
    "vilamovician": [
        8385
    ],
    "volga oirat": [
        8398,
        8399
    ],
    "volga": [
        8398,
        8399
    ],
    "velepa": [
        8459
    ],
    "vazama": [
        8684
    ],
    "venetic": [
        8685
    ],
    "vandalic": [
        8687
    ],
    "volscian": [
        8688
    ],
    "vestinian": [
        8689
    ],
    "veiao": [
        8733,
        8734
    ],
    "vona ubuvala": [
        8848
    ],
    "vona": [
        8848
    ],
    "vuteen": [
        8911
    ],
    "vahmbanj": [
        8966
    ],
    "villa alta zapotec": [
        8990
    ],
    "vahcuengh": [
        9016
    ],
    "vàng": [
        9110
    ],
    "vawngtu": [
        9185
    ]
};
